import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxGalleryModule } from 'ngx-gallery';
import { AgmCoreModule } from '@agm/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { MnFullpageModule } from 'ngx-fullpage';
import { HeaderComponent } from './componentes/header/header.component';
import { FooterComponent } from './componentes/footer/footer.component';
import { HomeComponent } from './componentes/home/home.component';
import { EmpresaComponent } from './componentes/empresa/empresa.component';
import { CoberturaComponent } from './componentes/cobertura/cobertura.component';
import { ServiciosComponent } from './componentes/servicios/servicios.component';
import { GaleriaComponent } from './componentes/galeria/galeria.component';
import { ContactoComponent } from './componentes/contacto/contacto.component';
import { ContenidoService } from './servicios/contenido.service';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    EmpresaComponent,
    CoberturaComponent,
    ServiciosComponent,
    GaleriaComponent,
    ContactoComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MnFullpageModule.forRoot(),
    NgxGalleryModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCBBH7m6scppxCFHQKGVK_Emmi24op6Xlw'
    })

  ],
  providers: [
    ContenidoService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/app.module.ts